import { storeToRefs } from 'pinia'

import { useCartStore } from '~/stores/cart'
import { useCartPromoStore } from '~/stores/cartPromo'
import { useMiscSendtrackStore } from '~/stores/miscSendtrack'
import { useUserAgencyStore } from '~/stores/userAgency'

export function useGrooverPlusPromo() {
  const { actions: PROMO_ACTIONS, IS_GROOVER_PLUS_PROMO_APPLIED } =
    storeToRefs(useCartPromoStore())
  const { IS_GROOVER_PLUS_MEMBER } = storeToRefs(useUserAgencyStore())
  const { promoUsedWithInvalidPercent: PROMO_USED_WITH_INVALID_PERCENT } =
    storeToRefs(useMiscSendtrackStore())
  const { price: CART_PRICE } = storeToRefs(useCartStore())

  const { FETCH_CART_AUTO_APPLY_PROMO } = useCartStore()

  const percentThreshold = computed<number>(() => {
    const promoAmount =
      PROMO_ACTIONS.value.campaign.value ||
      PROMO_USED_WITH_INVALID_PERCENT.value?.actions.campaign.value
    return promoAmount ? Math.round(100 / promoAmount) : 0
  })

  const hasValidAmountForPromo = computed(() =>
    IS_GROOVER_PLUS_MEMBER.value
      ? CART_PRICE.value >= percentThreshold.value
      : true,
  )

  function autoApplyBestPromoForGrooverPlusMember() {
    if (IS_GROOVER_PLUS_MEMBER.value && !IS_GROOVER_PLUS_PROMO_APPLIED.value)
      FETCH_CART_AUTO_APPLY_PROMO()
  }

  return {
    hasValidAmountForPromo,
    percentThreshold,
    autoApplyBestPromoForGrooverPlusMember,
  }
}
